/**
 * Flo Payments official brand mark — serves the finalized brand assets from
 * /public/brand/ directly (no inline SVG approximation).
 *
 * Variants:
 *   - "primary"      → flo-icon-primary.svg   (blue tile, F cutout) — use on light bg
 *   - "inverse"      → flo-icon-inverse.svg   (light tile, blue F)  — use on dark bg
 *   - "lockup-light" → flo-lockup-light.png   (icon + "Flo Payments" text) — light bg
 *   - "lockup-dark"  → flo-lockup-dark.png    (icon + "Flo Payments" text) — dark bg
 *
 * The container is transparent (no background fill). `size` controls the icon
 * height in px; lockups scale their width proportionally.
 */
const SRC = {
  primary: "/brand/flo-icon-primary-512.png",
  inverse: "/brand/flo-icon-inverse-512.png",
  "lockup-light": "/brand/flo-lockup-light.png",
  "lockup-dark": "/brand/flo-lockup-dark.png",
};

const IS_LOCKUP = (v) => v === "lockup-light" || v === "lockup-dark";

export default function FloLogo({ variant = "primary", size = 36, className = "", ...rest }) {
  const src = SRC[variant] || SRC.primary;
  const isLockup = IS_LOCKUP(variant);
  return (
    <img
      src={src}
      alt="Flo Payments"
      height={size}
      // Icons render as squares. Lockups keep their intrinsic aspect ratio (icon+text).
      style={{
        height: `${size}px`,
        width: isLockup ? "auto" : `${size}px`,
        background: "transparent",
        display: "block",
        objectFit: "contain",
      }}
      className={className}
      draggable={false}
      {...rest}
    />
  );
}
